module.exports = __webpack_public_path__ + "static/media/dt4logomini.2b455b6e.svg";